import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import * as Sentry from '@sentry/react'
import { AuthProvider, useAuth } from './lib/AuthProvider'
import './index.css'

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

import { routeTree } from './routeTree.gen'
import { NotFound } from './components/NotFound'

const router = createRouter({
  routeTree,
  defaultNotFoundComponent: NotFound,
  context: {
    auth: undefined!, // Injected down below
  },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}



function InnerApp() {
  const auth = useAuth()

  useEffect(() => {
    router.invalidate()
  }, [auth.user, auth.hasOnboarded])

  if (auth.isLoading) {
    return <div className="min-h-screen flex items-center justify-center">Carregando aplicação...</div>
  }
  return <RouterProvider router={router} context={{ auth }} />
}

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient()

import { CompanyProvider } from './lib/CompanyProvider'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <CompanyProvider>
          <InnerApp />
        </CompanyProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
